<template>
    <div id="ranking">
        <table v-if="false" class="ranking-table w-full ">
            <thead>
                <tr>
                    <th>排名</th>
                    <th>省区域</th>
                    <th>综试区</th>
                    <th>指数得分</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in dataList">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.region }}</td>
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.indexScore }}</td>
                </tr>
            </tbody>
        </table>




        <!-- <div class="list-container">
            <div class="marquee" id="carList">
                <template v-for="(item, index) in dataList">
                    <div class="list-item">
                        <div class="item-name text-overflow">{{ item }}</div>
                    </div>
                </template>
</div>
</div> -->
        <div class="ranking-table">

            <div class="flex justify-around t-header">
                <span style="width:40px" class="inline-block th">序号</span>
                <span style="width:80px" class="inline-block  th">地区</span>
                <span style="width:140px" class="inline-block th">跨境电商企业数量</span>
            </div>
            <vue-seamless-scroll :data="dataList" :class-option="classOption" class="warp">
                <ul class="">
                    <li v-for="(item, index) in dataList" :key="index" class="flex justify-around tr">
                        <span style="width:40px" class="inline-block td">
                            <span v-show="index > 3"> {{ index + 1 }}</span>
                            <img class="inline-block" v-show="index == 0" src="@/assets/img/数字.png" alt="">
                            <img class="inline-block" v-show="index == 1" src="@/assets/img/数字 (1).png" alt="">
                            <img class="inline-block" v-show="index == 2" src="@/assets/img/数字 (2).png" alt="">
                            <img class="inline-block" v-show="index == 3" src="@/assets/img/数字 (3).png" alt="">

                        </span>
                        <span style="width:80px" class="inline-block td" v-text="item.districtName"></span>
                        <span style="width:140px" class="inline-block td"
                            v-text="formatNumber(Number(item.totalEcommerceCount))"></span>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>

    </div>
</template>

<script>
import { lsdRegionEcommerceStatIndex } from '@/api/home.js'
import vueSeamlessScroll from 'vue-seamless-scroll'

import { buildDynamicCompareData, formatNumber } from '@/utils/tools.js'

export default {
    name: "",
    components: {
        vueSeamlessScroll
    },
    props: {},
    data() {
        return {

            classOption: {
                step: 0.3
            },
            // 海城区108、银海区19、铁山港区27、合浦县8  企业数量按这个数据填
            dataList: [{
                region: "海城区",
                indexScore: "108",
            },
            {
                region: "铁山港区",
                indexScore: "27",
            },
            {
                region: "银海区",
                indexScore: "19",
            }, {
                region: "合浦县",
                indexScore: "8",
            },
            ]
        };
    },
    watch: {},
    computed: {},
    methods: {
        formatNumber,
        async init() {
            try {
                const res = await lsdRegionEcommerceStatIndex({})
                this.dataList = res.data[0].children[0].children
            } catch (err) {
                this.$message.error("数据加载失败")
            }

        }
    },
    created() { },
    async mounted() {
        await this.init();
    }
}
</script>
<style lang="scss" scoped>
#ranking {
    padding: 23px 37px;

    .ranking-table {
        .t-header {
            // background-color: #15233f;
            height: 29px;
            font-size: 14px;
            color: #CFDEEB;
            ;
        }

        .th {
            text-align: center;
            // padding: 8px 0;
        }

        .tr:nth-child(odd) {
            background: linear-gradient(270deg, #203749 27%, rgba(32, 55, 73, 0) 100%);
            border: 1px solid;
            border-left: none;
            border-image: linear-gradient(270deg, rgba(102, 140, 172, 0.4), rgba(102, 140, 172, 0)) 0.5;
        }

        .tr:nth-child(even) {
            background: linear-gradient(270deg, #213341 27%, rgba(22, 40, 73, 0) 100%);
            border: 1px solid;
            border-left: none;
            border-image: linear-gradient(270deg, rgba(72, 106, 135, 0.4), rgba(102, 140, 172, 0)) 0.5;
        }


        // .tr:nth-child(1) {
        //     @apply  font-bold;
        //     color: red;

        // }

        // .tr:nth-child(2) {
        //     @apply  font-bold;
        //     color: rgb(255, 168, 7);
        // }

        // .tr:nth-child(3) {
        //     @apply  font-bold;
        //     color: rgb(255, 255, 0);
        // }

        .td {
            text-align: center;
            // padding: 8px 0;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
        }

    }

    .warp {
        height: 155px;
        margin: 0 auto;
        overflow: hidden;

        ul {
            list-style: none;
            padding: 0;
            margin: 0 auto;


            li,
            a {
                display: block;
                line-height: 30px;
                display: flex;
                margin-bottom: 3px;
                border-radius: 3px;

            }
        }
    }

}
</style>